export {default} from './Ellipsis';



// WEBPACK FOOTER //
// ./src/components/Ellipsis/index.ts